import { createSlice } from "@reduxjs/toolkit";
import {
  ClientInterface,
  WorkingPointClientsInterface,
  ClientsInterface,
  ClientsWorkingPointsDataInterface,
  ClientsWorkingPointsInterface,
  ScheduleWorkingPointsDetailsInterface,
  ScheduleWorkingPointsInterface,
  ScheduleWorkingRoutesDetailsInterface,
  ScheduleWorkingRoutesInterface,
  WorkingRoutesNodesInterface,
  AwbHistoryInterface,
  BinHistoryInterface,
  UndeliveredAwbInterface,
  UndeliveredAwbDataInterface,
  InternodeRoutesInterface,
  NonExistentNodesOnRouteInterface,
  AwbStatusesInterface,
  ActivePackagesInterface,
  BinStatusesInterface,
  NodeBinsInterface,
  AwbHistoryDataInterface,
  BinsVolumeInterface,
  BinsFromVolumeInterface,
  ScannedPackagesFromBinInterface,
  BinsFromVolumeDataInterface,
  OversizedPackagesInterface,
} from "../interfaces/expedition.interface";

import {
  fetchAwbHistory,
  fetchBinHistory,
  fetchBinsList,
  fetchNonExistentNodesForRoute,
  fetchUndeliveredAwb,
  getActivePackages,
  getAllWorkingRoutes,
  getAwbStatuses,
  getBinsFromVolume,
  getBinStatuses,
  getBinsVolume,
  getClient,
  getClientsByPctLucru,
  getClients,
  getClientsWorkingPoints,
  getInternodeRouteDetails,
  getInternodeRouteNodes,
  getInternodeRoutes,
  getOversizedPackages,
  getPackagesInWrongNode,
  getScannedPackagesFromBin,
  getScheduleWorkingPoints,
  getScheduleWorkingPointsDetails,
  getUnscannedPackagesInVolume,
  getWorkingRoutes,
  getWorkingRoutesDetails,
  getWorkingRoutesNodes,
} from "../api/expedition.api";

const initialExpeditionState: {
  workingPointClients: WorkingPointClientsInterface;
  scheduleWorkingPoints: ScheduleWorkingPointsInterface;
  scheduleWorkingPointsDetails: ScheduleWorkingPointsDetailsInterface;
  scheduleWorkingRoutes: ScheduleWorkingRoutesInterface;
  allWorkingRoutes: ScheduleWorkingRoutesInterface;
  scheduleWorkingRoutesDetails: ScheduleWorkingRoutesDetailsInterface;
  workingRoutesNodes: WorkingRoutesNodesInterface;
  clientsWorkingPoints: ClientsWorkingPointsInterface;
  clients: ClientsInterface;
  client: ClientInterface;
  clientSelectedWorkingPoint: ClientsWorkingPointsDataInterface | null;
  awbHistory: AwbHistoryInterface;
  binHistory: BinHistoryInterface;
  undeliveredAwb: UndeliveredAwbInterface;
  clientSelectedUndeliveredAwb: UndeliveredAwbDataInterface | null;
  internodeRoutes: InternodeRoutesInterface;
  internodeRouteNodes: WorkingRoutesNodesInterface;
  newNodesForInternodeRoute: NonExistentNodesOnRouteInterface;
  isNonExistingNodesModalOpen: boolean;
  awbStatuses: AwbStatusesInterface;
  activePackages: ActivePackagesInterface;
  nodeBins: NodeBinsInterface;
  binStatuses: BinStatusesInterface;
  clientsSelectedActiveExpedition: AwbHistoryDataInterface[];
  binsVolume: BinsVolumeInterface;
  binsFromVolume: BinsFromVolumeInterface;
  scannedPackagesFromBin: ScannedPackagesFromBinInterface;
  selectedBinFromVolume: BinsFromVolumeDataInterface | null;
  isDownloadBinModalOpen: boolean;
  clientsSelectedActiveExpeditionForNode: AwbHistoryDataInterface[];
  clientsSelectedActiveExpeditionForPickUpRoute: AwbHistoryDataInterface[];
  ovsersizedPackages: OversizedPackagesInterface;
} = {
  workingPointClients: {
    data: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  scheduleWorkingPoints: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  scheduleWorkingPointsDetails: {
    data: {
      days: [],
      pctLucru: null,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  scheduleWorkingRoutes: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  allWorkingRoutes: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  scheduleWorkingRoutesDetails: {
    data: {
      days: [],
      ruta: null,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  workingRoutesNodes: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  clientsWorkingPoints: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  clients: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  client: {
    data: null,
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  clientSelectedWorkingPoint: null,
  awbHistory: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  binHistory: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  undeliveredAwb: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  clientSelectedUndeliveredAwb: null,
  internodeRoutes: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  internodeRouteNodes: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  newNodesForInternodeRoute: {
    data: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  isNonExistingNodesModalOpen: false,
  awbStatuses: {
    data: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  activePackages: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  nodeBins: {
    data: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  binStatuses: {
    data: [],
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  clientsSelectedActiveExpedition: [],
  binsVolume: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  binsFromVolume: {
    nrColeteVolum: 0,
    nrColeteVolumScanate: 0,
    binuri: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  scannedPackagesFromBin: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  selectedBinFromVolume: null,
  isDownloadBinModalOpen: false,
  clientsSelectedActiveExpeditionForNode: [],
  clientsSelectedActiveExpeditionForPickUpRoute: [],
  ovsersizedPackages: {
    data: {
      current_page: 1,
      data: [],
      last_page: 1,
      perPage: 1,
      total: 1,
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
};

const expeditionReducer = createSlice({
  name: "expedition",
  initialState: initialExpeditionState,
  reducers: {
    clearWorkingPointClients: (state) => {
      state.workingPointClients = initialExpeditionState.workingPointClients;
    },
    clearScheduleWorkingPoints: (state) => {
      return {
        ...state,
        scheduleWorkingPoints: {
          ...initialExpeditionState.scheduleWorkingPoints,
        },
      };
    },
    clearScheduleWorkingRoutes: (state) => {
      return {
        ...state,
        scheduleWorkingRoutes: {
          ...initialExpeditionState.scheduleWorkingRoutes,
        },
      };
    },
    clearAllWorkingRoutes: (state) => {
      return {
        ...state,
        allWorkingRoutes: {
          ...initialExpeditionState.allWorkingRoutes,
        },
      };
    },
    clearWorkingRoutesNodes: (state) => {
      return {
        ...state,
        workingRoutesNodes: {
          ...initialExpeditionState.workingRoutesNodes,
        },
      };
    },
    resetScheduleWorkingPointsDetails: (state) => {
      return {
        ...state,
        scheduleWorkingPointsDetails: {
          ...initialExpeditionState.scheduleWorkingPointsDetails,
        },
      };
    },
    resetScheduleWorkingRoutesDetails: (state) => {
      return {
        ...state,
        scheduleWorkingRoutesDetails: {
          ...initialExpeditionState.scheduleWorkingRoutesDetails,
        },
      };
    },
    setClientSelectedWorkingPoint: (
      state,
      action: {
        payload: ClientsWorkingPointsDataInterface | null;
      },
    ) => {
      return {
        ...state,
        clientSelectedWorkingPoint: action.payload,
      };
    },
    clearClientsWorkingPoints: (state) => {
      return {
        ...state,
        clientsWorkingPoints: initialExpeditionState.clientsWorkingPoints,
      };
    },
    clearClient: (state) => {
      return {
        ...state,
        client: initialExpeditionState.client,
      };
    },
    setClientStatus: (
      state,
      action: {
        payload: {
          idClient: number | string;
          status: number;
        };
      },
    ) => {
      return {
        ...state,
        clients: {
          ...state.clients,
          data: {
            ...state.clients.data,
            data: state.clients.data.data.map((client) => {
              if (client.idClient === action.payload.idClient) {
                return {
                  ...client,
                  status: !!action.payload.status,
                };
              }
              return client;
            }),
          },
        },
      };
    },
    clearAwbHistory: (state) => {
      return {
        ...state,
        awbHistory: initialExpeditionState.awbHistory,
      };
    },
    clearActivePackages: (state) => {
      state.activePackages = initialExpeditionState.activePackages;
    },
    clearBinHistory: (state) => {
      return {
        ...state,
        binHistory: initialExpeditionState.binHistory,
      };
    },
    removeUndeliveredAwb: (state, action) => {
      return {
        ...state,
        undeliveredAwb: {
          ...state.undeliveredAwb,
          data: {
            ...state.undeliveredAwb.data,
            data: state.undeliveredAwb.data.data.filter(
              (awb) => awb.id_doctrans !== action.payload,
            ),
          },
        },
      };
    },
    setClientSelectedUndeliveredAwb: (
      state,
      action: {
        payload: UndeliveredAwbDataInterface | null;
      },
    ) => {
      return {
        ...state,
        clientSelectedUndeliveredAwb: action.payload,
      };
    },
    clearInternodeRoutes: (state) => {
      return {
        ...state,
        internodeRoutes: initialExpeditionState.internodeRoutes,
      };
    },
    clearInternodeRouteNodes: (state) => {
      return {
        ...state,
        internodeRouteNodes: initialExpeditionState.internodeRouteNodes,
      };
    },
    openAddNodeModal: (state) => {
      state.isNonExistingNodesModalOpen = true;
    },
    closeAddNodeModal: (state) => {
      state.isNonExistingNodesModalOpen = false;
    },
    setClientsSelectedActiveExpedition: (
      state,
      action: {
        payload: AwbHistoryDataInterface[];
      },
    ) => {
      return {
        ...state,
        clientsSelectedActiveExpedition: action.payload,
      };
    },
    clearPackagesFromBin: (state) => {
      return {
        ...state,
        scannedPackagesFromBin: initialExpeditionState.scannedPackagesFromBin,
      };
    },
    setSelectedBinFromVolume: (
      state,
      action: {
        payload: BinsFromVolumeDataInterface | null;
      },
    ) => {
      return {
        ...state,
        selectedBinFromVolume: action.payload,
      };
    },
    openDownloadBinModal: (state) => {
      state.isDownloadBinModalOpen = true;
    },
    closeDownloadBinModal: (state) => {
      state.isDownloadBinModalOpen = false;
    },
    setClientsSelectedActiveExpeditionForNode: (
      state,
      action: {
        payload: AwbHistoryDataInterface[];
      },
    ) => {
      return {
        ...state,
        clientsSelectedActiveExpeditionForNode: action.payload,
      };
    },
    setClientsSelectedActiveExpeditionForPickUpRoute: (
      state,
      action: {
        payload: AwbHistoryDataInterface[];
      },
    ) => {
      return {
        ...state,
        clientsSelectedActiveExpeditionForPickUpRoute: action.payload,
      };
    },
    clearOversizedPackages: (state) => {
      return {
        ...state,
        ovsersizedPackages: initialExpeditionState.ovsersizedPackages,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getClientsByPctLucru.pending, (state, action) => {
      state.workingPointClients = {
        ...initialExpeditionState.workingPointClients,
        isLoading: true,
        requestId: action.meta.requestId,
      };
    });
    builder.addCase(getClientsByPctLucru.fulfilled, (state, action) => {
      if (state.workingPointClients.requestId !== action.meta.requestId) return;
      state.workingPointClients.data = action.payload;
      state.workingPointClients.isLoading = false;
    });
    builder.addCase(getClientsByPctLucru.rejected, (state, action) => {
      if (state.workingPointClients.requestId !== action.meta.requestId) return;
      state.workingPointClients.isLoading = false;
      state.workingPointClients.isError = true;
      state.workingPointClients.errorMessage =
        (action.payload as { message?: string } | undefined)?.message ||
        "Lista clientilor nu a putut fi incarcata.";
    });
    // get schedule working points start
    builder.addCase(getScheduleWorkingPoints.pending, (state) => {
      return {
        ...state,
        scheduleWorkingPoints: {
          ...initialExpeditionState.scheduleWorkingPoints,
          isLoading: true,
        },
      };
    });
    builder.addCase(getScheduleWorkingPoints.rejected, (state, action: any) => {
      return {
        ...state,
        scheduleWorkingPoints: {
          ...state.scheduleWorkingPoints,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getScheduleWorkingPoints.fulfilled, (state, action) => {
      return {
        ...state,
        scheduleWorkingPoints: {
          ...state.scheduleWorkingPoints,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get schedule working points end

    // get  schedule working routes details start
    builder.addCase(getScheduleWorkingPointsDetails.pending, (state) => {
      return {
        ...state,
        scheduleWorkingPointsDetails: {
          ...initialExpeditionState.scheduleWorkingPointsDetails,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      getScheduleWorkingPointsDetails.rejected,
      (state, action: any) => {
        return {
          ...state,
          scheduleWorkingPointsDetails: {
            ...state.scheduleWorkingPointsDetails,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(
      getScheduleWorkingPointsDetails.fulfilled,
      (state, action) => {
        return {
          ...state,
          scheduleWorkingPointsDetails: {
            ...state.scheduleWorkingPointsDetails,
            isLoading: false,
            data: action.payload,
          },
        };
      },
    );
    // end get schedule working points details end
    // get schedule working routes start
    builder.addCase(getWorkingRoutes.pending, (state) => {
      return {
        ...state,
        scheduleWorkingRoutes: {
          ...initialExpeditionState.scheduleWorkingRoutes,
          isLoading: true,
        },
      };
    });
    builder.addCase(getWorkingRoutes.rejected, (state, action: any) => {
      return {
        ...state,
        scheduleWorkingRoutes: {
          ...state.scheduleWorkingRoutes,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });

    builder.addCase(getWorkingRoutes.fulfilled, (state, action) => {
      return {
        ...state,
        scheduleWorkingRoutes: {
          ...state.scheduleWorkingRoutes,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get schedule working routes end
    // get all working routes start
    builder.addCase(getAllWorkingRoutes.pending, (state) => {
      return {
        ...state,
        allWorkingRoutes: {
          ...initialExpeditionState.allWorkingRoutes,
          isLoading: true,
        },
      };
    });
    builder.addCase(getAllWorkingRoutes.rejected, (state, action: any) => {
      return {
        ...state,
        allWorkingRoutes: {
          ...state.allWorkingRoutes,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getAllWorkingRoutes.fulfilled, (state, action) => {
      return {
        ...state,
        allWorkingRoutes: {
          ...state.allWorkingRoutes,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get all working routes end
    // get  schedule working routes details start
    builder.addCase(getWorkingRoutesDetails.pending, (state) => {
      return {
        ...state,
        scheduleWorkingRoutesDetails: {
          ...initialExpeditionState.scheduleWorkingRoutesDetails,
          isLoading: true,
        },
      };
    });
    builder.addCase(getWorkingRoutesDetails.rejected, (state, action: any) => {
      return {
        ...state,
        scheduleWorkingRoutesDetails: {
          ...state.scheduleWorkingRoutesDetails,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getWorkingRoutesDetails.fulfilled, (state, action) => {
      return {
        ...state,
        scheduleWorkingRoutesDetails: {
          ...state.scheduleWorkingRoutesDetails,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    //  get  schedule working routes details end

    // get intranod route details start
    builder.addCase(getInternodeRouteDetails.pending, (state) => {
      return {
        ...state,
        scheduleWorkingRoutesDetails: {
          ...initialExpeditionState.scheduleWorkingRoutesDetails,
          isLoading: true,
        },
      };
    });
    builder.addCase(getInternodeRouteDetails.rejected, (state, action: any) => {
      return {
        ...state,
        scheduleWorkingRoutesDetails: {
          ...state.scheduleWorkingRoutesDetails,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getInternodeRouteDetails.fulfilled, (state, action) => {
      return {
        ...state,
        scheduleWorkingRoutesDetails: {
          ...state.scheduleWorkingRoutesDetails,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get intranod route details end

    // get working routes nodes start
    builder.addCase(getWorkingRoutesNodes.pending, (state) => {
      return {
        ...state,
        workingRoutesNodes: {
          ...initialExpeditionState.workingRoutesNodes,
          isLoading: true,
        },
      };
    });
    builder.addCase(getWorkingRoutesNodes.rejected, (state, action: any) => {
      return {
        ...state,
        workingRoutesNodes: {
          ...state.workingRoutesNodes,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getWorkingRoutesNodes.fulfilled, (state, action) => {
      return {
        ...state,
        workingRoutesNodes: {
          ...state.workingRoutesNodes,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get working routes nodes end

    // get clients working points start
    builder.addCase(getClientsWorkingPoints.pending, (state) => {
      return {
        ...state,
        clientsWorkingPoints: {
          ...initialExpeditionState.clientsWorkingPoints,
          isLoading: true,
        },
      };
    });
    builder.addCase(getClientsWorkingPoints.rejected, (state, action: any) => {
      return {
        ...state,
        clientsWorkingPoints: {
          ...state.clientsWorkingPoints,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getClientsWorkingPoints.fulfilled, (state, action) => {
      return {
        ...state,
        clientsWorkingPoints: {
          ...state.clientsWorkingPoints,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get clients working points end

    // get clients start
    builder.addCase(getClients.pending, (state) => {
      return {
        ...state,
        clients: {
          ...initialExpeditionState.clients,
          isLoading: true,
        },
      };
    });
    builder.addCase(getClients.rejected, (state, action: any) => {
      return {
        ...state,
        clients: {
          ...state.clients,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getClients.fulfilled, (state, action) => {
      return {
        ...state,
        clients: {
          ...state.clients,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get clients end
    // get client start
    builder.addCase(getClient.pending, (state) => {
      return {
        ...state,
        client: {
          ...initialExpeditionState.client,
          isLoading: true,
        },
      };
    });
    builder.addCase(getClient.rejected, (state, action: any) => {
      return {
        ...state,
        client: {
          ...state.client,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getClient.fulfilled, (state, action) => {
      return {
        ...state,
        client: {
          ...state.client,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get client end
    // get awb history start
    builder.addCase(fetchAwbHistory.pending, (state, action) => {
      return {
        ...state,
        awbHistory: {
          ...initialExpeditionState.awbHistory,
          requestId: action.meta.requestId,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchAwbHistory.rejected, (state, action: any) => {
      if (state.awbHistory.requestId !== action.meta.requestId) return;
      return {
        ...state,
        awbHistory: {
          ...state.awbHistory,
          isLoading: false,
          errorMessage: action.payload?.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchAwbHistory.fulfilled, (state, action) => {
      if (state.awbHistory.requestId !== action.meta.requestId) return;
      return {
        ...state,
        awbHistory: {
          ...state.awbHistory,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // awb history end
    // bin history start

    builder.addCase(fetchBinHistory.pending, (state, action) => {
      return {
        ...state,
        binHistory: {
          ...initialExpeditionState.binHistory,
          requestId: action.meta.requestId,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchBinHistory.rejected, (state, action: any) => {
      if (state.binHistory.requestId !== action.meta.requestId) return;
      return {
        ...state,
        binHistory: {
          ...state.binHistory,
          isLoading: false,
          errorMessage: action.payload?.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchBinHistory.fulfilled, (state, action) => {
      if (state.binHistory.requestId !== action.meta.requestId) return;
      return {
        ...state,
        binHistory: {
          ...state.binHistory,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // bin history end
    // get undelivered awb start
    builder.addCase(fetchUndeliveredAwb.pending, (state) => {
      return {
        ...state,
        undeliveredAwb: {
          ...initialExpeditionState.undeliveredAwb,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchUndeliveredAwb.rejected, (state, action: any) => {
      return {
        ...state,
        undeliveredAwb: {
          ...state.undeliveredAwb,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(fetchUndeliveredAwb.fulfilled, (state, action) => {
      return {
        ...state,
        undeliveredAwb: {
          ...state.undeliveredAwb,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get undelivered awb end

    // get internode routes start
    builder.addCase(getInternodeRoutes.pending, (state) => {
      return {
        ...state,
        internodeRoutes: {
          ...initialExpeditionState.internodeRoutes,
          isLoading: true,
        },
      };
    });
    builder.addCase(getInternodeRoutes.rejected, (state, action: any) => {
      return {
        ...state,
        internodeRoutes: {
          ...state.internodeRoutes,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getInternodeRoutes.fulfilled, (state, action) => {
      return {
        ...state,
        internodeRoutes: {
          ...state.internodeRoutes,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get internode routes end

    // get internode route nodes start
    builder.addCase(getInternodeRouteNodes.pending, (state) => {
      return {
        ...state,
        internodeRouteNodes: {
          ...initialExpeditionState.internodeRouteNodes,
          isLoading: true,
        },
      };
    });
    builder.addCase(getInternodeRouteNodes.rejected, (state, action: any) => {
      return {
        ...state,
        internodeRouteNodes: {
          ...state.internodeRouteNodes,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getInternodeRouteNodes.fulfilled, (state, action) => {
      return {
        ...state,
        internodeRouteNodes: {
          ...state.internodeRouteNodes,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get internode route nodes end

    // get nodes to add for internode route start
    builder.addCase(fetchNonExistentNodesForRoute.pending, (state) => {
      return {
        ...state,
        newNodesForInternodeRoute: {
          ...initialExpeditionState.newNodesForInternodeRoute,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      fetchNonExistentNodesForRoute.rejected,
      (state, action: any) => {
        return {
          ...state,
          newNodesForInternodeRoute: {
            ...state.newNodesForInternodeRoute,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(
      fetchNonExistentNodesForRoute.fulfilled,
      (state, action) => {
        return {
          ...state,
          newNodesForInternodeRoute: {
            ...state.newNodesForInternodeRoute,
            isLoading: false,
            data: action.payload,
          },
        };
      },
    );
    // get nodes to add for internode route end

    // get awb statuses start
    builder.addCase(getAwbStatuses.pending, (state) => {
      return {
        ...state,
        awbStatuses: {
          ...initialExpeditionState.awbStatuses,
          isLoading: true,
        },
      };
    });
    builder.addCase(getAwbStatuses.rejected, (state, action: any) => {
      return {
        ...state,
        awbStatuses: {
          ...state.awbStatuses,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getAwbStatuses.fulfilled, (state, action) => {
      return {
        ...state,
        awbStatuses: {
          ...state.awbStatuses,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get awb statuses end

    // get active packages start
    builder.addCase(getActivePackages.pending, (state, action) => {
      return {
        ...state,
        activePackages: {
          ...initialExpeditionState.activePackages,
          requestId: action.meta.requestId,
          isLoading: true,
        },
      };
    });
    builder.addCase(getActivePackages.rejected, (state, action: any) => {
      if (state.activePackages.requestId !== action.meta.requestId) return;
      return {
        ...state,
        activePackages: {
          ...state.activePackages,
          isLoading: false,
          errorMessage: action.payload?.message,
          isError: true,
        },
      };
    });
    builder.addCase(getActivePackages.fulfilled, (state, action) => {
      if (state.activePackages.requestId !== action.meta.requestId) return;
      return {
        ...state,
        activePackages: {
          ...state.activePackages,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get active packages end

    // fetchBinsList
    builder.addCase(fetchBinsList.pending, (state) => {
      return {
        ...state,
        nodeBins: {
          ...initialExpeditionState.nodeBins,
          isLoading: true,
        },
      };
    });
    builder.addCase(fetchBinsList.rejected, (state, action: any) => {
      return {
        ...state,
        nodeBins: {
          ...initialExpeditionState.nodeBins,
          isLoading: false,
          isError: true,
          errorMessage: action.payload.message,
        },
      };
    });
    builder.addCase(fetchBinsList.fulfilled, (state, action) => {
      return {
        ...state,
        nodeBins: {
          ...initialExpeditionState.nodeBins,
          data: action.payload,
        },
      };
    });
    // end fetchBinsList

    // get bin statuses start
    builder.addCase(getBinStatuses.pending, (state) => {
      return {
        ...state,
        binStatuses: {
          ...initialExpeditionState.binStatuses,
          isLoading: true,
        },
      };
    });
    builder.addCase(getBinStatuses.rejected, (state, action: any) => {
      return {
        ...state,
        binStatuses: {
          ...state.binStatuses,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getBinStatuses.fulfilled, (state, action) => {
      return {
        ...state,
        binStatuses: {
          ...state.binStatuses,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get bin statuses end

    // get bins volume start
    builder.addCase(getBinsVolume.pending, (state) => {
      return {
        ...state,
        binsVolume: {
          ...initialExpeditionState.binsVolume,
          isLoading: true,
        },
      };
    });
    builder.addCase(getBinsVolume.rejected, (state, action: any) => {
      return {
        ...state,
        binsVolume: {
          ...state.binsVolume,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getBinsVolume.fulfilled, (state, action) => {
      return {
        ...state,
        binsVolume: {
          ...state.binsVolume,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get bins volume end

    // get bins from volume start
    builder.addCase(getBinsFromVolume.pending, (state) => {
      return {
        ...state,
        binsFromVolume: {
          ...initialExpeditionState.binsFromVolume,
          isLoading: true,
        },
      };
    });
    builder.addCase(getBinsFromVolume.rejected, (state, action: any) => {
      return {
        ...state,
        binsFromVolume: {
          ...state.binsFromVolume,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getBinsFromVolume.fulfilled, (state, action) => {
      return {
        ...state,
        binsFromVolume: {
          ...state.binsFromVolume,
          isLoading: false,
          ...action.payload,
        },
      };
    });
    // get bins from volume end

    // get scanned packages from bin start
    builder.addCase(getScannedPackagesFromBin.pending, (state) => {
      return {
        ...state,
        scannedPackagesFromBin: {
          ...initialExpeditionState.scannedPackagesFromBin,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      getScannedPackagesFromBin.rejected,
      (state, action: any) => {
        return {
          ...state,
          scannedPackagesFromBin: {
            ...state.scannedPackagesFromBin,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(getScannedPackagesFromBin.fulfilled, (state, action) => {
      return {
        ...state,
        scannedPackagesFromBin: {
          ...state.scannedPackagesFromBin,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get scanned packages from bin  end

    // get unscanned packages in volume start
    builder.addCase(getUnscannedPackagesInVolume.pending, (state) => {
      return {
        ...state,
        scannedPackagesFromBin: {
          ...initialExpeditionState.scannedPackagesFromBin,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      getUnscannedPackagesInVolume.rejected,
      (state, action: any) => {
        return {
          ...state,
          scannedPackagesFromBin: {
            ...state.scannedPackagesFromBin,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(getUnscannedPackagesInVolume.fulfilled, (state, action) => {
      return {
        ...state,
        scannedPackagesFromBin: {
          ...state.scannedPackagesFromBin,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get unscanned packages in volume  end

    // get  packages in wrong node start
    builder.addCase(getPackagesInWrongNode.pending, (state) => {
      return {
        ...state,
        scannedPackagesFromBin: {
          ...initialExpeditionState.scannedPackagesFromBin,
          isLoading: true,
        },
      };
    });
    builder.addCase(getPackagesInWrongNode.rejected, (state, action: any) => {
      return {
        ...state,
        scannedPackagesFromBin: {
          ...state.scannedPackagesFromBin,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getPackagesInWrongNode.fulfilled, (state, action) => {
      return {
        ...state,
        scannedPackagesFromBin: {
          ...state.scannedPackagesFromBin,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // get  packages in wrong node end

    // get ovsersized packages start
    builder.addCase(getOversizedPackages.pending, (state) => {
      return {
        ...state,
        ovsersizedPackages: {
          ...initialExpeditionState.ovsersizedPackages,
          isLoading: true,
        },
      };
    });
    builder.addCase(getOversizedPackages.rejected, (state, action: any) => {
      return {
        ...state,
        ovsersizedPackages: {
          ...state.ovsersizedPackages,
          isLoading: false,
          errorMessage: action.payload?.message,
          isError: true,
        },
      };
    });
    builder.addCase(getOversizedPackages.fulfilled, (state, action) => {
      return {
        ...state,
        ovsersizedPackages: {
          ...state.ovsersizedPackages,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // awb ovsersized packages end
  },
});

export const {
  clearWorkingPointClients,
  clearScheduleWorkingPoints,
  clearScheduleWorkingRoutes,
  clearAllWorkingRoutes,
  clearWorkingRoutesNodes,
  resetScheduleWorkingPointsDetails,
  resetScheduleWorkingRoutesDetails,
  setClientSelectedWorkingPoint,
  clearClientsWorkingPoints,
  clearClient,
  setClientStatus,
  clearAwbHistory,
  clearActivePackages,
  clearBinHistory,
  removeUndeliveredAwb,
  setClientSelectedUndeliveredAwb,
  clearInternodeRouteNodes,
  clearInternodeRoutes,
  openAddNodeModal,
  closeAddNodeModal,
  setClientsSelectedActiveExpedition,
  setClientsSelectedActiveExpeditionForNode,
  setClientsSelectedActiveExpeditionForPickUpRoute,
  clearPackagesFromBin,
  setSelectedBinFromVolume,
  openDownloadBinModal,
  closeDownloadBinModal,
  clearOversizedPackages,
} = expeditionReducer.actions;

export default expeditionReducer.reducer;
